// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as RestApi$DvmAdminFrontendFr from "../../../api/RestApi.bs.js";
import * as Order_Detail_Types$DvmAdminFrontendFr from "./Order_Detail_Types.bs.js";

function getOrder(userManager, setOrder, orderId, selectedRole) {
  Curry._1(setOrder, (function (param) {
          return /* Pending */1;
        }));
  RestApi$DvmAdminFrontendFr.call("GET", Order_Detail_Types$DvmAdminFrontendFr.order_decode, undefined, userManager, selectedRole, "/orders/" + orderId + "/detail").then(function (result) {
        if (result.TAG === /* OkResult */0) {
          var order = result._0;
          return Curry._1(setOrder, (function (param) {
                        return {
                                TAG: /* Ok */0,
                                _0: order
                              };
                      }));
        }
        var error = result._0;
        Curry._1(setOrder, (function (param) {
                return {
                        TAG: /* Error */1,
                        _0: error
                      };
              }));
      });
}

export {
  getOrder ,
}
/* RestApi-DvmAdminFrontendFr Not a pure module */
